/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Add_To_Pdf_SuccessInputs */



/**
* | output |
* | --- |
* | "Plan added successfully" |
*
* @param {Intervention_Plan_Add_To_Pdf_SuccessInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_add_to_pdf_success = /** @type {((inputs?: Intervention_Plan_Add_To_Pdf_SuccessInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Add_To_Pdf_SuccessInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Plan added successfully")
	return /** @type {LocalizedString} */ ("Le plan a été ajouté avec succès")
});